<script>
  export default {
    name: 'drop-shadow'
  }
</script>

<template>
  <svg height="0" xmlns="http://www.w3.org/2000/svg">
    <filter id="drop-shadow">
      <feGaussianBlur in="SourceAlpha" stdDeviation="4"/>
      <feOffset dx="4" dy="4" result="offsetblur"/>
      <feFlood flood-color="rgba(0,0,0,0.5)"/>
      <feComposite in2="offsetblur" operator="in"/>
      <feMerge>
        <feMergeNode/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </svg>
</template>

<style src="./DropShadow.scss" lang="scss"></style>
